export default "__VITE_ASSET__BpJz1Z9a__"